"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Router = _interopRequireDefault(require("../../utils/Router"));
var _SessionHandler = _interopRequireDefault(require("../../utils/SessionHandler"));
var _contractAccountReducerTypes = require("../../common/features/ContractAccountManagement/types/contractAccountReducerTypes");
var _contractAccount = _interopRequireDefault(require("../../common/features/ContractAccountManagement/functions/contractAccount"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var initialState = {
  contractId: '',
  data: [],
  isLoading: true,
  apiError: false,
  apiErrorMessage: ''
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var contracts = state.data || [];
  var selectedContractId = contracts.some(function (contract) {
    return contract.contractAccountId === action.selectedContractId;
  }) ? action.selectedContractId || '' : '';
  switch (action.type) {
    case _contractAccountReducerTypes.ContractsAccountActions.IS_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: true
      });
    case _contractAccountReducerTypes.ContractsAccountActions.LOAD_CURRENT_CONTRACTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.contractAccounts,
        contractId: (0, _contractAccount.default)(action.contractAccounts || []),
        isLoading: false,
        apiError: false,
        apiErrorMessage: ''
      });
    case _contractAccountReducerTypes.ContractsAccountActions.SET_SELECTED_CONTRACT:
      _SessionHandler.default.setPermissions(state.data, selectedContractId);
      _Router.default.setParameter({
        contractAccId: selectedContractId
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        contractId: selectedContractId,
        isLoading: false
      });
    case _contractAccountReducerTypes.ContractsAccountActions.SET_CONTRACT_WITHOUT_HASH:
      _SessionHandler.default.setPermissions(state.data, selectedContractId);
      return _objectSpread(_objectSpread({}, state), {}, {
        contractId: selectedContractId,
        isLoading: false
      });
    case _contractAccountReducerTypes.ContractsAccountActions.SET_API_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        apiError: true,
        apiErrorMessage: action.apiErrorMessage
      });
    default:
      return state;
  }
}